import { axiosAWSConsumer as axiosConsumer } from "../../utils";

export const insertAceCliam = async (body: any) => {
  const { data } = await axiosConsumer.post(`/ace/insert_claim`, body);
  return data.result;
};

export const insertAceClaimItems = async (body: any) => {
  const { data } = await axiosConsumer.post(`/ace/insert_claim_item`, body);
  return data;
};

export const insertAceClaimItemsDamage = async (body: any) => {
  const { data } = await axiosConsumer.post(
    `/ace/insert_claim_item_damage`,
    body
  );
  return data;
};

export const getAceClaim = async (claimId: Number | string) => {
  const { data } = await axiosConsumer.get(`/ace/claim/${claimId}`);
  return data.result;
};

export const removeAceClaimItems = async (claimId, itemId) => {
  const { data } = await axiosConsumer.delete(
    `/ace/remove_claim_items/${claimId}/${itemId}`
  );
  return data;
};

export const removeAceClaimItemDamage = async (damegeId) => {
  const { data } = await axiosConsumer.delete(
    `/ace/delete_claim_item_damage/${damegeId}`
  );
  return data;
};

export const submitAceClaim = async (claimId) => {
  try {
    const { data } = await axiosConsumer.put(`/ace/submit_claim/${claimId}`);
    return data;
  } catch (error) {
    console.log("error:", error);
    if (error.response && error.response.status === 504) {
      return { message: "Succeed" };
    } else {
      throw error;
    }
  }
};

export const aceClaimItemsSaveInfo = async (body: any) => {
  const { data } = await axiosConsumer.post(
    `/ace/insert_linked_and_embedded_files`,
    body
  );
  return data?.result || [];
};

export const getPreSignedUrl = async (
  claimId: string,
  fileType: string
): Promise<string | null> => {
  const { data } = await axiosConsumer.get(`/ace/file-upload-url`, {
    params: {
      claimId,
      fileType,
    },
  });
  return data;
};

export const removeAceClaimImage = async (docId) => {
  const { data } = await axiosConsumer.delete(
    `/ace/delete_uploaded_documents_of_claim/${docId}`
  );
  return data;
};
